<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { handleNext } from '../tutorialSteps'

const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_military_intro')
}

const isOnCommandSection = computed(() => {
  return route.path.startsWith('/command/ships')
})

const goToCommand = () => {
  router.push('/command/ships')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/military.webm"
  >
    <template #text>
      <p class="pb-2">
        Greetings, I'm your military advisor.
      </p>
      <p class="pb-2">
        Now that you've established your government and research capabilities, it's time to look at our military strength.
      </p>
      <p class="pb-2">
        The Command Center is where you'll manage your fleets, design new ships, and coordinate military operations across your empire.
      </p>
      <p class="pb-2">
        A strong military is essential for protecting your planets and expanding your territory. Let's get started!
      </p>
    </template>

    <template #alerts>
      <Alert type="info" class="hidden md:flex">
        Click on the "Command" button in the top menu.
      </Alert>
      <Alert type="info" class="md:hidden">
        Click on the "Menu" in the right top of your screen, then select "Command".
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnCommandSection" @click="goToCommand" class="mr-2">
        Go to Command
      </ActionButton>
      <ActionButton @click="handleNextStep">
        Lets go!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>